import { render, staticRenderFns } from "./ProductFiltersModal.vue?vue&type=template&id=bf11660e&scoped=true"
import script from "./ProductFiltersModal.vue?vue&type=script&lang=js"
export * from "./ProductFiltersModal.vue?vue&type=script&lang=js"
import style0 from "./ProductFiltersModal.vue?vue&type=style&index=0&id=bf11660e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf11660e",
  null
  
)

export default component.exports